import React from "react";

const AuthExpiredModal = ({ show, onLogin }) => {
    if (!show) return null;
    return (
        <div
            className="modal show"
            style={{
                display: "block",
                background: "rgba(0,0,0,0.5)",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 9999,
            }}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Session Expired</h5>
                    </div>
                    <div className="modal-body">
                        <p>
                            Your login session has expired or is invalid. Please
                            login again.
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={onLogin}>
                            Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { AuthExpiredModal };
